import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchUserOrganizations } from "./usersService";
export var useFetchUserOrganizations = function (userId) {
    var ky = useOkapiKy();
    return useQuery(["organizations", userId], function () { return fetchUserOrganizations(ky, userId); }, { enabled: Boolean(userId) });
};
